<script>
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import {lookup2,disabledBeforeTodayDates} from '@/apis/common'
import {saveOrder} from '@/apis/order'
import LanguageSwitch from '../../components/language-switch';
import {
  required
} from "vuelidate/lib/validators";
/**
 * Form Repeater component
 */
export default {
  page: {
    title: "Higg FEM Verification Application Form",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout,DatePicker,Multiselect,LanguageSwitch},
  validations: {
    form: {
      clientName: { 
            required,
      },
      taxCode: { 
            check(value){
                if (localStorage.getItem('language')!="zh-CN"&&value!=null && value.trim().length === 0) {
                  return false;
                }else{
                  return true;
                }                
            },
      },
      country: { 
        required,
      },
      address: { 
            required,
      },
      contact: { 
            required,
      },
      title: { 
            required,
      },
      mobile: { 
            required,
      },
      email: { 
            required,
      },
      companyInfo:{
          chemical:{
            required
          },
          wwt:{
            required
          },
          coverarea:{
            required
          },
          employee:{
            required
          }
      },
      orderDetail:{
        auditDateFrom:{
          required
        },
        auditDateTo:{
          required
        }
      }
    },
  },
  props:{
    sales:{
      type: String,
      required: false
    }
  },
  data() {
    return {
      title: "Higg验证申请",
      orderNo:null,
      clientNo:null,
      showTaxCode:false,
      showLegalPerson:false,
      disabledDates: disabledBeforeTodayDates,
      form:{
        orderId:null,
        orderType:"Higg",
        orderSource:"ON-LINE",
        orderStatus:'N',
        paymentStatus:'Y',
        orderDetail:{
          type:"FEM",
          model:"Onsite",
          experience:"1",
          selfassessment:"y",
          auditDateFrom:"",
          auditDateTo:"",
          envManagementSystem:1,
          energyGreenhouseGases:1,
          waterResources:1,
          wastewater:1,
          exhaustEmissions:1,
          waste:1,
          chemicalManagement:1,
          higgID:""
        },
        clientId:null,
        clientName:"",
        clientNameEn:"",
        taxCode:"",
        country:"",
        province:"",
        city:"",
        station:"",
        address:"",
        addressEn:"",
        promoteBrand:"",
        companyInfo:{
          productType:"",
          technology:"",
          chemical:"",
          wwt:"",
          coverarea:"",
          employee:"",
          esc:"",
          legalPersonName:"",
          legalPersonTitle:""
        },
        contact:"",
        email:"",
        mobile:"",
        title:"",
        department:"",
        salesTag:"",
      },
      submitted:false,
      success:false,
      lookupRawData:{},
      lookupData:{
        businessType:[],
        industry:[],
        travel:[],
        cnty:{},
      },
      lookupDataSelected:{
        businessType:[],
        industry:[],
        cnty:[]
      },
    };
  },
  created(){
    if(this.$route.query.tag!=undefined){
      this.form.salesTag = this.$route.query.tag;
    }
    this.init();
  },
  watch:{
    "lookupDataSelected.cnty"(){
      if(this.lookupDataSelected.cnty.value!=undefined){
        this.form.country = this.lookupDataSelected.cnty.value
      }
    },
    "form.country"(){
      if(this.form.country=='VN'){
        this.showLegalPerson = true
      }else{
        this.showLegalPerson = false
      }
    },
    "form.address"(){
      if(this.form.address.indexOf("省")!=-1||this.form.address.indexOf("市")!=-1){
        let address = this.form.address.replace("，",",").split("市")[0].replace("中国","").trim()
        if(address.indexOf("省")!=-1){
          let province_city = address.split("省")
          this.form.city = ""||province_city[1].trim()
        }else{
          this.form.city = address
        }
      }
    },    
  },
  methods: {
    async init(){
      // 初始化数据字典
      this.lookupRawData = await lookup2("BUSINESS-TYPE,INDUSTRY,CNTY");
      this.lookupData.businessType = this.lookupRawData["BUSINESS-TYPE"].map(item=>{return {...item,labelCn:item.label}});
      this.lookupData.industry = this.lookupRawData["INDUSTRY"].map(item=>{return {...item,labelCn:item.label}});
      this.lookupData.cnty = this.lookupRawData["CNTY"].map(item=>{return {...item,labelCn:item.label}});
      this.changeLookupLanguage()
    },
    changeLookupLanguage(){
      if(localStorage.getItem('language')=="zh-CN"){
        this.showTaxCode = false;
        this.lookupData.businessType = this.lookupData.businessType.map(item=>{return {...item,label:item.labelCn}});
        this.lookupData.industry = this.lookupData.industry.map(item=>{return {...item,label:item.labelCn}});
        this.lookupData.cnty = this.lookupData.cnty.map(item=>{return {...item,label:item.labelCn}});
      }else{
        this.showTaxCode = true;
        this.lookupData.businessType = this.lookupData.businessType.map(item=>{return {...item,label:item.labelEn}});
        this.lookupData.industry = this.lookupData.industry.map(item=>{return {...item,label:item.labelEn}});
        this.lookupData.cnty = this.lookupData.cnty.map(item=>{return {...item,label:item.labelEn}});
      }
    },
    handleSaveClient() {
      this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
            this.success = false
            return;
        } else {
          let params = {...this.form}
          params.sales = this.sales
          params.companyInfo = JSON.stringify(this.form.companyInfo)
          params.orderDetail = JSON.stringify(this.form.orderDetail)
          params.language = localStorage.getItem('language')
          params.serviceYear = this.form.orderDetail.auditDateFrom.substring(0,4)
          if(this.lookupDataSelected.businessType.value!=undefined){
            params.businessType = this.lookupDataSelected.businessType.value
          }
          if(this.lookupDataSelected.industry.value!=undefined){
            params.industry = this.lookupDataSelected.industry.value
          }
          if(this.lookupDataSelected.cnty.value!=undefined){
            params.country = this.lookupDataSelected.cnty.value
          }
          this.success = true
          saveOrder('Higg',params).then(()=>{
            Swal.fire(this.$t("common.successMsg"),"", "success");
          }).catch(()=>{
            this.success = false;
          })
        }
    },
    handleGoHome(){
      this.$router.push({
          name: 'home',
      })
    }

  },
};
</script>

<template>
  <Layout>
    <div class="row  mt-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" style="padding-top: 0px;">
                        <div class="row">
                          <div class="col-lg-2 col-sm-1 logo-col" >
                            <a href="http://www.greenpont.com/" class="logo">
                                <span class="logo-sm">
                                  <img src="@/assets/images/logo-sm.svg" alt height="22" />
                                </span>
                                <span class="logo-lg">
                                  <img src="@/assets/images/logo-dark.svg" alt height="36" />
                                </span>
                            </a>
                          </div>
                          <div class="col-lg-8 col-sm-10 text-center" >
                            <h5 class="card-title" style="line-height: 70px;"><span class="logo-icon">
                              <a href="http://www.greenpont.com/"><img src="@/assets/images/logo-sm.svg" alt height="22" /></a>
                              </span>{{$t("fem.formName")}}</h5>
                          </div>
                        </div>
                        <language-switch @change="changeLookupLanguage"></language-switch>
                        <form class="needs-validation">
                          <div class="card border shadow-none mb-5">
                                <div class="card-header d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3">
                                        <div class="avatar">
                                            <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                                01
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h5 class="card-title">{{$t("common.verfRequirement")}}</h5>
                                    </div>
                                </div>
                                <div class="card-body">
                                  <div class="mb-3">
                                    <label class="form-label mb-3 d-flex">{{$t("fem.type")}}:</label>
                                    <div class="form-check">
                                      <input
                                        type="radio"
                                        id="type1"
                                        name="type"
                                        class="form-check-input"
                                        value="Foundation"
                                        v-model="form.orderDetail.type"
                                      />
                                      <label class="form-check-label" for="type1"
                                        >{{$t("fem.typeFoundation")}}</label
                                      >
                                    </div>
                                    <div class="form-check">
                                      <input
                                        type="radio"
                                        id="type2"
                                        name="type"
                                        class="form-check-input"
                                        value="FEM"
                                        v-model="form.orderDetail.type"
                                      />
                                      <label class="form-check-label" for="type2"
                                        >{{$t("fem.typeFEM")}}</label
                                      >
                                    </div>
                                  </div>
                                  <div v-if="form.orderDetail.type=='FEM'">
                                    <div>
                                      <label class="form-label mb-3 d-flex">{{$t("fem.self")}}:</label>
                                      <div class="form-check form-check-inline">
                                        <label class="form-check-label" for="experience1" style="width: 100px;">{{$t("fem.envManagementSystem")}}</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="envManagementSystem1"
                                          name="envManagementSystem"
                                          class="form-check-input"
                                          value="1"
                                          v-model="form.orderDetail.envManagementSystem"
                                        />
                                        <label class="form-check-label" for="envManagementSystem1">Level 1</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="envManagementSystem2"
                                          name="envManagementSystem"
                                          class="form-check-input"
                                          value="2"
                                          v-model="form.orderDetail.envManagementSystem"
                                        />
                                        <label class="form-check-label" for="envManagementSystem2">Level 2</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="envManagementSystem3"
                                          name="envManagementSystem"
                                          class="form-check-input"
                                          value="3"
                                          v-model="form.orderDetail.envManagementSystem"
                                        />
                                        <label class="form-check-label" for="envManagementSystem3">Level 3</label>
                                      </div>
                                    </div>
                                    <div>
                                      <label class="form-label mb-3 d-flex"></label>
                                      <div class="form-check form-check-inline">
                                        <label class="form-check-label" for="experience1" style="width: 100px;">{{$t("fem.energyGreenhouseGases")}}</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="energyGreenhouseGases1"
                                          name="energyGreenhouseGases"
                                          class="form-check-input"
                                          value="1"
                                          v-model="form.orderDetail.energyGreenhouseGases"
                                        />
                                        <label class="form-check-label" for="energyGreenhouseGases1">Level 1</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="energyGreenhouseGases2"
                                          name="energyGreenhouseGases"
                                          class="form-check-input"
                                          value="2"
                                          v-model="form.orderDetail.energyGreenhouseGases"
                                        />
                                        <label class="form-check-label" for="energyGreenhouseGases2">Level 2</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="energyGreenhouseGases3"
                                          name="energyGreenhouseGases"
                                          class="form-check-input"
                                          value="3"
                                          v-model="form.orderDetail.energyGreenhouseGases"
                                        />
                                        <label class="form-check-label" for="energyGreenhouseGases3">Level 3</label>
                                      </div>
                                    </div>
                                    <div>
                                      <label class="form-label mb-3 d-flex"></label>
                                      <div class="form-check form-check-inline">
                                        <label class="form-check-label" for="experience1" style="width: 100px;">{{$t("fem.waterResources")}}</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="waterResources1"
                                          name="waterResources"
                                          class="form-check-input"
                                          value="1"
                                          v-model="form.orderDetail.waterResources"
                                        />
                                        <label class="form-check-label" for="waterResources1">Level 1</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="waterResources2"
                                          name="waterResources"
                                          class="form-check-input"
                                          value="2"
                                          v-model="form.orderDetail.waterResources"
                                        />
                                        <label class="form-check-label" for="waterResources2">Level 2</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="waterResources3"
                                          name="waterResources"
                                          class="form-check-input"
                                          value="3"
                                          v-model="form.orderDetail.waterResources"
                                        />
                                        <label class="form-check-label" for="waterResources3">Level 3</label>
                                      </div>
                                    </div>
                                    <div>
                                      <label class="form-label mb-3 d-flex"></label>
                                      <div class="form-check form-check-inline">
                                        <label class="form-check-label" for="experience1" style="width: 100px;">{{$t("fem.wastewater")}}</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="wastewater1"
                                          name="wastewater"
                                          class="form-check-input"
                                          value="1"
                                          v-model="form.orderDetail.wastewater"
                                        />
                                        <label class="form-check-label" for="wastewater1">Level 1</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="wastewater2"
                                          name="wastewater"
                                          class="form-check-input"
                                          value="2"
                                          v-model="form.orderDetail.wastewater"
                                        />
                                        <label class="form-check-label" for="wastewater2">Level 2</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="wastewater3"
                                          name="wastewater"
                                          class="form-check-input"
                                          value="3"
                                          v-model="form.orderDetail.wastewater"
                                        />
                                        <label class="form-check-label" for="wastewater3">Level 3</label>
                                      </div>
                                    </div>
                                    <div>
                                      <label class="form-label mb-3 d-flex"></label>
                                      <div class="form-check form-check-inline">
                                        <label class="form-check-label" for="experience1" style="width: 100px;">{{$t("fem.exhaustEmissions")}}</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="exhaustEmissions1"
                                          name="exhaustEmissions"
                                          class="form-check-input"
                                          value="1"
                                          v-model="form.orderDetail.exhaustEmissions"
                                        />
                                        <label class="form-check-label" for="exhaustEmissions1">Level 1</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="exhaustEmissions2"
                                          name="exhaustEmissions"
                                          class="form-check-input"
                                          value="2"
                                          v-model="form.orderDetail.exhaustEmissions"
                                        />
                                        <label class="form-check-label" for="exhaustEmissions2">Level 2</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="exhaustEmissions3"
                                          name="exhaustEmissions"
                                          class="form-check-input"
                                          value="3"
                                          v-model="form.orderDetail.exhaustEmissions"
                                        />
                                        <label class="form-check-label" for="exhaustEmissions3">Level 3</label>
                                      </div>
                                    </div>
                                    <div>
                                      <label class="form-label mb-3 d-flex"></label>
                                      <div class="form-check form-check-inline">
                                        <label class="form-check-label" for="experience1" style="width: 100px;">{{$t("fem.waste")}}</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="waste1"
                                          name="waste"
                                          class="form-check-input"
                                          value="1"
                                          v-model="form.orderDetail.waste"
                                        />
                                        <label class="form-check-label" for="waste1">Level 1</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="waste2"
                                          name="waste"
                                          class="form-check-input"
                                          value="2"
                                          v-model="form.orderDetail.waste"
                                        />
                                        <label class="form-check-label" for="waste2">Level 2</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="waste3"
                                          name="waste"
                                          class="form-check-input"
                                          value="3"
                                          v-model="form.orderDetail.waste"
                                        />
                                        <label class="form-check-label" for="waste3">Level 3</label>
                                      </div>
                                    </div>
                                    <div class="mb-3">
                                      <label class="form-label mb-3 d-flex"></label>
                                      <div class="form-check form-check-inline">
                                        <label class="form-check-label" for="experience1" style="width: 100px;">{{$t("fem.chemicalManagement")}}</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="chemicalManagement1"
                                          name="chemicalManagement"
                                          class="form-check-input"
                                          value="1"
                                          v-model="form.orderDetail.chemicalManagement"
                                        />
                                        <label class="form-check-label" for="experience1">Level 1</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="chemicalManagement2"
                                          name="chemicalManagement"
                                          class="form-check-input"
                                          value="2"
                                          v-model="form.orderDetail.chemicalManagement"
                                        />
                                        <label class="form-check-label" for="chemicalManagement2">Level 2</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input
                                          type="radio"
                                          id="chemicalManagement3"
                                          name="chemicalManagement"
                                          class="form-check-input"
                                          value="3"
                                          v-model="form.orderDetail.chemicalManagement"
                                        />
                                        <label class="form-check-label" for="chemicalManagement3">Level 3</label>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="mb-3">
                                    <label class="form-label mb-3 d-flex">{{$t("fem.experience")}}:</label>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="experience1"
                                        name="experience"
                                        class="form-check-input"
                                        value="1"
                                        v-model="form.orderDetail.experience"
                                      />
                                      <label class="form-check-label" for="experience1">{{$t("fem.experience1")}}</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="experience2"
                                        name="experience"
                                        class="form-check-input"
                                        value="2"
                                        v-model="form.orderDetail.experience"
                                      />
                                      <label class="form-check-label" for="experience2">{{$t("fem.experience2")}}</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="experience3"
                                        name="experience"
                                        class="form-check-input"
                                        value="3"
                                        v-model="form.orderDetail.experience"
                                      />
                                      <label class="form-check-label" for="experience3">{{$t("fem.experience3")}}</label>
                                    </div>
                                  </div>
                                  <div class="mb-3">
                                    <label class="form-label mb-3 d-flex">{{$t("fem.model")}}:</label>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="model1"
                                        name="model"
                                        class="form-check-input"
                                        value="Onsite"
                                        v-model="form.orderDetail.model"
                                      />
                                      <label class="form-check-label" for="model1">{{$t("fem.model1")}}</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="model2"
                                        name="model"
                                        class="form-check-input"
                                        value="Offsite"
                                        v-model="form.orderDetail.model"
                                      />
                                      <label class="form-check-label" for="model2">{{$t("fem.model2")}}</label>
                                    </div>
                                  </div>
                                  <div class="mb-3">
                                    <label class="form-label mb-3 d-flex">{{$t("fem.selfassessment")}}:</label>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="selfassessment1"
                                        name="selfassessment"
                                        class="form-check-input"
                                        value="y"
                                        v-model="form.orderDetail.selfassessment"
                                      />
                                      <label class="form-check-label" for="selfassessment1">{{$t("common.yes")}}</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="selfassessment2"
                                        name="selfassessment"
                                        class="form-check-input"
                                        value="n"
                                        v-model="form.orderDetail.selfassessment"
                                      />
                                      <label class="form-check-label" for="selfassessment2">{{$t("common.no")}}</label>
                                    </div>
                                  </div>
                                  <div class="mb-3">
                                    <label class="form-label" for="higgID">Worldly (Higg) ID :</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="higgID"
                                      v-model="form.orderDetail.higgID"
                                    />
                                  </div>

                                  <div class="mb-3">
                                    <label class="form-label" for="promoteBrand">{{$t("fem.promoteBrand")}} :</label>
                                    <input
                                      type="email"
                                      class="form-control"
                                      id="promoteBrand"
                                      v-model="form.promoteBrand"
                                    />
                                  </div>
                                  <div class="mb-3">
                                    <label class="form-label">{{$t("fem.auditDate")}} :</label>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <date-picker
                                          v-model="form.orderDetail.auditDateFrom"
                                          format="YYYY-MM-DD"
                                          value-type="format"
                                          :disabled-date="disabledDates"
                                          :first-day-of-week="1"
                                          lang="en"
                                          placeholder="from"
                                          :class="{
                                              'is-invalid': submitted && $v.form.orderDetail.auditDateFrom.$error,
                                          }"
                                        ></date-picker>
                                        <div
                                            v-if="submitted && $v.form.orderDetail.auditDateFrom.$error"
                                            class="invalid-feedback"
                                            >
                                                <span v-if="!$v.form.orderDetail.auditDateFrom.required">
                                                  {{$t("fem.auditDateError")}}.
                                                </span>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <date-picker
                                          v-model="form.orderDetail.auditDateTo"
                                          format="YYYY-MM-DD"
                                          value-type="format"
                                          :disabled-date="disabledDates"
                                          :first-day-of-week="1"
                                          lang="en"
                                          placeholder="to"
                                          :class="{
                                              'is-invalid': submitted && $v.form.orderDetail.auditDateTo.$error,
                                          }"
                                        ></date-picker>
                                        <div
                                            v-if="submitted && $v.form.orderDetail.auditDateTo.$error"
                                            class="invalid-feedback"
                                            >
                                                <span v-if="!$v.form.orderDetail.auditDateTo.required">
                                                  {{$t("fem.auditDateError")}}.
                                                </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            </div>
                            <div class="card border shadow-none mb-5">
                                <div class="card-header d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3">
                                        <div class="avatar">
                                            <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                                02
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h5 class="card-title">{{$t("common.baseInfo")}}</h5>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div>
                                        <div class="row">
                                            <div class="col-lg-6 mb-3">
                                                    <label class="form-label" for="gen-info-name-input">{{$t("common.clientNameLocal")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-name-input" v-model="form.clientName"
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.clientName.$error,
                                                    }">
                                                    <div
                                                        v-if="submitted && $v.form.clientName.$error"
                                                        class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.clientName.required">
                                                              {{$t("common.clientNameLocalError")}}.
                                                            </span>
                                                    </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="mb-3">
                                                    <label class="form-label" for="gen-info-name-en-input">{{$t("common.clientNameEn")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-name-en-input" v-model="form.clientNameEn">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" v-show="showTaxCode">
                                            <div class="col-lg-6 mb-3">
                                                    <label class="form-label" for="gen-info-taxcode-input">{{$t("common.taxCode")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-taxcode-input" v-model="form.taxCode"
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.taxCode.$error,
                                                    }">
                                                    <div
                                                        v-if="submitted && $v.form.taxCode.$error"
                                                        class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.taxCode.check">
                                                              {{$t("common.taxCodeError")}}.
                                                            </span>
                                                    </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="gen-info-country-input">{{$t("common.country")}}</label>
                                                <multiselect 
                                                id="gen-info-country-input"
                                                v-model="lookupDataSelected.cnty" 
                                                :options="lookupData.cnty"
                                                label="label"
                                                track-by="value"
                                                :class="{
                                                        'is-invalid': submitted && $v.form.country.$error,
                                                    }"
                                                ></multiselect>
                                                <div
                                                    v-if="submitted && $v.form.country.$error"
                                                    class="invalid-feedback"
                                                    >
                                                        <span v-if="!$v.form.country.required">
                                                          {{$t("common.countryError")}}.
                                                        </span>
                                                </div>
                                            </div>
                                            <div class="col-lg-6 mb-3">
                                                    <label class="form-label" for="gen-info-province-input">{{$t("common.province")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-province-input" v-model="form.province">
                                            </div>                                            
                                        </div>                                        
                                        <div class="row">
                                            <div class="col-lg-6 mb-3">
                                                    <label class="form-label" for="gen-info-address-input">{{$t("common.addressLocal")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-address-input" v-model="form.address"
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.address.$error,
                                                    }">
                                                    <div
                                                        v-if="submitted && $v.form.address.$error"
                                                        class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.address.required">
                                                              {{$t("common.addressLocalError")}}.
                                                            </span>
                                                    </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="mb-3">
                                                    <label class="form-label" for="gen-info-address-en-input">{{$t("common.addressEn")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-address-en-input" v-model="form.addressEn">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-12 mb-3">
                                                    <label class="form-label" for="gen-info-station-input">{{$t("common.station")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-station-input" v-model="form.station">
                                            </div>                                            
                                        </div>                                            
                                        <div class="row">
                                            <div class="col-lg-6 mb-3">
                                                <label class="form-label" for="gen-info-industry-input">{{$t("common.industry")}}</label>
                                                <multiselect 
                                                id="gen-info-industry-input"
                                                v-model="lookupDataSelected.industry" 
                                                :options="lookupData.industry"
                                                label="label"
                                                track-by="value"
                                                ></multiselect>
                                            </div>
                                            <div class="col-lg-6 mb-3">
                                                <label class="form-label" for="gen-info-businessType-input">{{$t("common.businessType")}}</label>
                                                <multiselect 
                                                id="gen-info-businessType-input"
                                                v-model="lookupDataSelected.businessType" 
                                                :options="lookupData.businessType"
                                                label="label"
                                                track-by="value"
                                                ></multiselect>
                                            </div>
                                        </div>
                                        <div class="row" v-if="showLegalPerson">
                                            <div class="col-lg-6 mb-3">
                                                    <label class="form-label" for="gen-info-legalPersonName-input">{{$t("common.legalPersonName")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-legalPersonName-input" v-model="form.companyInfo.legalPersonName">
                                            </div>
                                            <div class="col-lg-6 mb">
                                                    <label class="form-label" for="gen-info-legalPersonTitle-en-input">{{$t("common.legalPersonTitle")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-legalPersonTitle-en-input" v-model="form.companyInfo.legalPersonTitle">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6 mb-3">
                                                    <label class="form-label" for="productType">{{$t("fem.productType")}}</label>
                                                    <input type="text" class="form-control" id="productType"   v-model="form.companyInfo.productType">
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="mb-3">
                                                    <label class="form-label" for="technology">{{$t("fem.technology")}}</label>
                                                    <input type="text" class="form-control" id="technology"  v-model="form.companyInfo.technology">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6 mb-3">
                                                    <label class="form-label" for="chemical">{{$t("fem.chemical")}}</label>
                                                    <input type="text" class="form-control" id="chemical"  v-model="form.companyInfo.chemical"
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.companyInfo.chemical.$error,
                                                    }">
                                                    <div
                                                        v-if="submitted && $v.form.companyInfo.chemical.$error"
                                                        class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.companyInfo.chemical.required">
                                                                {{$t("common.pleaseDetail")}}.
                                                            </span>
                                                    </div>
                                            </div>
                                            
                                            <div class="col-lg-6">
                                                <div class="mb-3">
                                                    <label class="form-label" for="wwt">{{$t("fem.wwt")}}</label>
                                                    <input type="text" class="form-control" id="wwt"  v-model="form.companyInfo.wwt"
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.companyInfo.wwt.$error,
                                                    }">
                                                    <div
                                                        v-if="submitted && $v.form.companyInfo.wwt.$error"
                                                        class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.companyInfo.wwt.required">
                                                              {{$t("common.pleaseDetail")}}.
                                                            </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6 mb-3">
                                                    <label class="form-label" for="coverarea">{{$t("fem.coverarea")}}</label>
                                                    <input type="text" class="form-control" id="coverarea" v-model="form.companyInfo.coverarea"
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.companyInfo.coverarea.$error,
                                                    }">
                                                    <div
                                                        v-if="submitted && $v.form.companyInfo.coverarea.$error"
                                                        class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.companyInfo.coverarea.required">
                                                              {{$t("fem.coverareaError")}}.
                                                            </span>
                                                    </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="mb-3">
                                                    <label class="form-label" for="employee">{{$t("fem.employee")}}</label>
                                                    <input type="text" class="form-control" id="employee"  v-model="form.companyInfo.employee"
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.companyInfo.employee.$error,
                                                    }">
                                                    <div
                                                        v-if="submitted && $v.form.companyInfo.employee.$error"
                                                        class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.companyInfo.employee.required">
                                                                {{$t("fem.employeeError")}}.
                                                            </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6 mb-3">
                                                    <label class="form-label" for="esc"> {{$t("fem.esc")}}</label>
                                                    <input type="text" class="form-control" id="esc" v-model="form.companyInfo.esc">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card border shadow-none mb-3">
                                <div class="card-header d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3">
                                        <div class="avatar">
                                            <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                                03
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h5 class="card-title">{{$t("common.contactInfo")}}</h5>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div>
                                        <div class="row">
                                            <div class="col-lg-6 mb-3">
                                                    <label class="form-label" for="gen-info-contact-input">{{$t("common.contact")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-contact-input" v-model="form.contact"
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.contact.$error,
                                                    }">
                                                    <div
                                                        v-if="submitted && $v.form.contact.$error"
                                                        class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.contact.required">
                                                              {{$t("common.contactError")}}.
                                                            </span>
                                                    </div>
                                            </div>
                                            <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="gen-info-title-input">{{$t("common.title")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-title-input" v-model="form.title"
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.title.$error,
                                                    }">
                                                    <div
                                                        v-if="submitted && $v.form.title.$error"
                                                        class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.title.required">
                                                              {{$t("common.titleError")}}.
                                                            </span>
                                                    </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6 mb-3">
                                                    <label class="form-label" for="gen-info-mobile-input">{{$t("common.mobile")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-mobile-input" v-model="form.mobile"
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.mobile.$error,
                                                    }">
                                                    <div
                                                        v-if="submitted && $v.form.mobile.$error"
                                                        class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.mobile.required">
                                                              {{$t("common.mobileError")}}.
                                                            </span>
                                                    </div>
                                            </div>
                                            <div class="col-lg-6 mb-3" >
                                                    <label class="form-label" for="gen-info-email-input">{{$t("common.email")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-email-input" v-model="form.email"
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.email.$error,
                                                    }">
                                                    <div
                                                        v-if="submitted && $v.form.email.$error"
                                                        class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.email.required">
                                                              {{$t("common.emailError")}}.
                                                            </span>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          </form>
                          <div>
                              <button type="button" class="btn btn-primary w-sm" @click="handleSaveClient" :disabled="success" >{{$t("common.submit")}}</button> {{$t("common.hotline")}}: +86 755 21608956/ +84 932 130 677
                              <button type="button" class="btn btn-btn-secondary w-sm" @click="handleGoHome" v-if="false">{{$t("common.moreService")}}</button>
                          </div>
                    </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<style lang="scss">
.is-invalid .mx-input-wrapper .mx-input{
    border: 1px solid #ec4561 !important;
  }
  .is-invalid .mx-input-wrapper .mx-icon-calendar{
    color: #ec4561 !important;
  }
  .is-invalid .multiselect__tags{
    border:1px solid #ec4561 !important;
  }
</style>
